import { Box, PressableIcon } from '@bonanza-social/moonlight';
import { SocialLink as SocialLinkType } from './SocialLinks.constants';
import { memo, useCallback } from 'react';
import { Linking } from 'react-native';
import { logError } from '@bonanza-social/toolkit/logging';

function SocialLink({ icon, link }: SocialLinkType) {
  const handlePress = useCallback(async () => {
    try {
      const canOpenLink = await Linking.canOpenURL(link);

      if (canOpenLink) {
        await Linking.openURL(link);
      }
    } catch (error) {
      logError('Error opening link', error);
    }
  }, [link]);

  return (
    <Box paddingRight="space-600">
      <PressableIcon
        name={icon}
        width="space-600"
        height="space-600"
        onPress={handlePress}
      />
    </Box>
  );
}

export default memo(SocialLink);
